<template>
  <div class="container has-text-centered">
    <section class="is-dark section">
      <div class="title">Our Solutions</div>
      <div class="subtitle">
        We provide expert technical support backed with years of experience
      </div>

      <div class="solutions">
        <SingleSolution
          v-for="(solution, index) in solutions"
          :key="index"
          :isLeft="index % 2 == 0"
          :vendor="solution.vendor"
          :image="solution.image"
          :title="solution.title"
          :messages="solution.messages"
        ></SingleSolution>
      </div>
    </section>
  </div>
</template>

<script>
import ScrollReveal from "scrollreveal";
import SingleSolution from "@/components/SingleSolution";

const solutions = [
  {
    title: "Enterprise API Management Platform",
    vendor: "Tyk",
    messages: [
      "The leading API and service management platform, an independent open-source API Gateway, API Management Dashboard & API Developer Portal. Provides mechanisms and tools to support developer and subscriber community, such as enforcing their usage policies, controlling access, collecting and analyzing usage statistics, and reporting on performance.  Secure, Lightweight, High Performance and cost effective. No vendor locked-in, freely run on any Cloud Platforms - AWS, Alibaba, etc or  hybrid environment of On-Prem & Cloud.",
    ],
    image: "management.svg",
  },
  {
    title: "Smart WIFI,  Smart Switches & Unified Management Solution",
    vendor: "Sundray",
    messages: [
      "Smart WIFI Solution: with Multi-in-1 (2.0 Firewall/Wireless IPS, Online to Off-line Marketing, Key Application Bandwidth Guarantee, Behavior Management & Auditing, Big-Data (User data mining, Dynamic Heat Map, Access Data Analysis, User Profiling, Client Walk Path, etc),  11 methods of Authentication/ Authorization & Seamless Roaming, VPN for Multi Sites. ",

      "Smart Switches: from different role of POE Switches, Smart Edge to Core Switches solution. Based on SDN architecture designed, the switch is Plug-and-Play, improving online efficiency.  ",

      "Unified Management with AI: Controllers with HA and unified configuration of entire large-scale networks consist of of Wifi Access Points, Switches & Enterprise IoT from HQ. Say goodbye to traditional command line. With secured full Web visual configuration, operation is no longer troublesome. Replace faulty equipment with zero business interruption.  Compare to traditional network field deployment, Sundray could save up to 91% of your deployment time.",
    ],
    image: "wifi.svg",
  },
  {
    title: "The 3rd Gen All-in-One HCI",
    vendor: "Sangfor",
    messages: [
      "3rd Generation of HCI (Hyper-Converged Infrastructure) is an infrastructure that not only combines the virtualization technologies of Computing, Networking, Storage, also providing Security & NFV (Next Gen Firewall, Application Delivery – Load Balancing, Internet behavior management), VPN and Built-in CDP with Near Zero RPO for protect your mission critical applications.  Software running on the industry-standard x86 servers with “What Your Draw is What You Get” easily scale-out, with 1 Management Console Removing Silos. Listed in the Gartner MQ x86 Server Virtualization Infrastructure.",
    ],
    image: "virtualisation.svg",
  },

  {
    title: "Virtual Desktops",
    vendor: "Sangfor",
    messages: [
      "Deeply Integrated Desktop Cloud with Outstanding Performance and Total Security. Assign and share physical resources when needed easily and intuitively. Multi-platform support (i.e. thin client, PC, iPad, iPhone and Android) makes VDI highly versatile. User experience under different network situations, includes desktop operation, business systems access, high-definition video playing, etc. Sangfor VDI is based on Sangfor HCI technology, and has successfully delivered more than 300k+ thin client units; more than 100 cases with 1k+ units deployment.",
    ],
    image: "virtual.svg",
  },

  {
    title: "Internet Access Management: A Secure Web Gateway and More",
    vendor: "Sangfor",
    messages: [
      "A superior Internet behavior management solution consisting of internet bandwidth management, application control, URL filters, traffic control, information control, illegal hotspot/proxy control, behavior analysis, wireless network management and many more features. This solution can truly help you achieve effective Web Filtering and unified internet behavior management of all clients in the entire network. Save at least 30% of customer’s bandwidth with high productivity and operation cost.",
    ],
    image: "identity.svg",
  },

  {
    title: "DR/HA solution for V2V or V2C",
    vendor: "Zerto",
    messages: [
      "World’s First Agent Less Hypervisor Based Replication HA, support in Same or Cross HyperVisor ( VMware to Hyper-V or vice versa, or to Cloud), Data Protection & Recovery for Kubernetes. Replication HA with Eternal Journal to replace your additional Data Backup requirements. Recovery from any Point-in-time of Entire Site/App/VM/File level. ( RPO in Sec ; RTO in Min ). With no DB & Application Agents are require.",
    ],
    image: "disaster_recovery.svg",
  },

  {
    title: "Secured Private Cloud File Sync n Sharing & Enterprise Backup CDP",
    vendor: "Ai-Shu",
    messages: [
      "Enterprise Backup/ CDP/ CDM* Solution support VMware, OpenStack, FusionSphere, AWS, MS Azure, Alibaba Cloud, H3C, Huawei Cloud, Tencent Cloud, eCloud, IBM Cloud ; Hi-Security Cloud File Share & Synchronize Solution.",
    ],
    image: "server.svg",
  },

  {
    title: "Backup, HA, Files & Email Archiving Solutions",
    vendor: "Veritas",
    messages: [
      "NetBackup: #1 in Enterprise Backup Solutions, Veritas named a 14-times Leader in the 2019 Gartner Magic Quadrant for Data Center Backup and Recovery. ",
      "Backup Exec: gives you fast, simple, complete, cost-effective protection and recovery for your data, wherever it lives.",
      "Enterprise Vault:  Automated Data Retention & Email Archiving. Veritas EV has been listed in Gartner Leader Quadrant for Enterprise Information Archiving for many years. ",
    ],
    image: "backup.svg",
  },

  {
    title: "ARM Micro-Server Based CEPH Software Defined Storage Appliance",
    vendor: "Ambedded",
    messages: [
      "CEPH is the Biggest Open Source SDS (Software Defined Storage) community with scalable up to the Exabyte level, is also the Most adaptive storage by OpenStack (& K8s) mass production (75%), including Telco, cloud service providers etc.",
      "AMBEDDED - the ARM Micro-Server based CEPH Storage Appliance - Saving 60% of Capex & 70% Power Consumption, Better Performance vs X86, Save Rack Space in Datacenter (1.6X) vs x86, Faster Re-healing vs x86, Smallest Failure Domain vs x86. Enterprise Storage Features: with  Auto Scale-out, Self Healing, Auto Balance, Multi-Sites Active-Active Support. Best application for VMware, Hyper-V, Openstack, K8s, S3 for CDR, Hadoop, Massive Data Backup (Veritas, Commvault, Veeam, Zerto), Elastic S3 to IoT/Edge Computing. ",
    ],
    image: "server_rack.svg",
  },

  {
    title: "SAN Storage & Scale-out NAS",
    vendor: "Infortrend",
    messages: [
      "EonStor DS: A Proven Cost Effective high availability General Purpose SAN storage solution designed for enterprises. EonStor DS supports a max. data thru-put of 11,000/5,500 MB/s and IOPS of 700K while providing numerous high speed protocols such as 16Gb/s FC and 40Gb/s iSCSI to handle various enterprise critical applications and IT deployment environments.",
      "EonStor CS: is a scale-out NAS storage system. By adding more CS units (nodes), you get a high performance/capacity cluster system with up to 100+ GBps Read/Write speed and more than 100PB of storage for the needs of future data growth. Advantages: High Performance I/O, Massive Data Storage and Elastic Scaling, Load Balancing, Easy Management.",
    ],
    image: "storage.svg",
  },

  {
    title:
      "Active Archive & Deep Unified Storage Gateway with Mixed Disk & Tape Automation - Up to Exabyte Capacity",
    vendor: "Spectra Logic",
    messages: [
      "Tape Library: Smallest Start from 6U 1 to 6LTO Drives, 10 to 80 Tape Slots. Up to 2 Exabyte, World’s Highest Capacity Storage System with Mixed Drives supported among: LTO, IBM TS11x0, Oracle T10000x.",
      "Unified Object Storage Gateway: with Mixed Disk Performance Disk, Capacity Disk & Tape Automation (Up to Exabyte Capacity).",
      "Active Archive: allows you to extend a file system across performance disk, capacity disk, and tape; all accessible to the end user without the intervention of an administrator. For the Media & Entertainment and High Performance Computing industries, active archiving techniques and software are being used to digitally preserve their assets and data.",
      "Library Migration: Spectra is unique in allowing other vendor’s * LTO drives to be moved into a new Spectra Stack tape library. Support Co-existing Old Drive & New Drive in a library with partition.",
    ],
    image: "datacenter.svg",
  },

  {
    title: "Tape System & RDX Removable Disk",
    vendor: "Overland",
    messages: [
      "LTO Single Tape/ Library & Media Cartridges; RDX - is a trusted Removable Disk Solution with Shock-Proof, PowerEncrypt Hardware Encryption, available in USB Stand-alone Disk or 4 or 8 bays Disk Array (with Volume-Spanning, equipped virtual Library feature) with iSCSI connectivity. RDX Cartridge available from 500GB to 5TB each. Many success case in the fields e.g: industrial environment, High-way Toll, project sites, Fighter Aircraft and so on.",
    ],
    image: "strong.svg",
  },

  {
    title: "LTO Cartridges & Accessories",
    vendor: "Fuji-Film",
    messages: [
      "Complete Range of LTO 1-8 Tape Data Cartridge & Cleaning Cartridge. Barcode Labels, LTO Transport Carrying Case.",
    ],
    image: "network.svg",
  },

  {
    title: "Storage Networking & Accessories",
    vendor: "ATTO",
    messages: [
      "The high-end ATTO Fibre Channel HBAs; SAS/SATA HBAs; RAID Adaptors; Ethernet Adaptors ; Thunderbolt Adaptors are built-in ATTO ADS",
      "ADS - The ATTO Exclusive Performance Technology to manage latency and provide controlled acceleration for smooth data streaming to maintain the highest consistent performance. ADS™ ensures best-in-industry data transfers for high-bandwidth applications (e.g. Media & Entertainment industry), which means better performance for end-users.",
    ],
    image: "fast.svg",
  },
];

export default {
  name: "Solutions",
  components: { SingleSolution },
  data: function () {
    return {
      solutions,
    };
  },
  mounted() {
    const defaultDelay = 300;
    const slideRight = {
      distance: "105%",
      origin: "left",
      duration: 1200,
      delay: defaultDelay,
    };

    const slideLeft = {
      distance: "120%",
      origin: "right",
      duration: 1200,
      mobile: false,
      delay: defaultDelay,
    };
    const sr = ScrollReveal(slideRight);

    sr.reveal(".item-left", slideRight);
    sr.reveal(".item-right", slideLeft);
  },
};
</script>

<style scoped>
.solutions {
  margin-top: 3rem;
}
</style>
